import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, TextButton, Typography } from 'seagull';
import { ExclamationMark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './BlockingErrorView.module.scss';
export const GetBlockingErrorViewTID = (parentTestId)=>getTestIds(parentTestId);
export function BlockingErrorView(param) {
    let { errorKind, testId, onDownloadTemplate } = param;
    const { t: blockingErrorTexts } = useLocaleKeys('pages.importClients.blockingError');
    const { BlockingErrorViewTestIds: TID } = useMemo(()=>GetBlockingErrorViewTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Callout, {
        skin: "transparent",
        intent: "error",
        iconSize: "small",
        icon: /*#__PURE__*/ _jsx(ExclamationMark, {
            size: 16,
            className: styles.icon,
            testId: TID.Icon()
        }),
        children: errorKind === 'missingColumns' ? /*#__PURE__*/ _jsxs(Typography, {
            variant: "paragraph2",
            testId: TID.Message(),
            children: [
                blockingErrorTexts.missingColumns.leading(),
                ' ',
                /*#__PURE__*/ _jsx(TextButton, {
                    onClick: onDownloadTemplate,
                    bi: {
                        name: 'import_clients_blocking_download_template'
                    },
                    variant: "paragraph2",
                    skin: "primary",
                    underline: "none",
                    testId: TID.TemplateLink(),
                    children: blockingErrorTexts.missingColumns.linkText()
                }),
                ' ',
                blockingErrorTexts.missingColumns.trailing()
            ]
        }) : /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraph2",
            testId: TID.Message(),
            children: blockingErrorTexts[errorKind].message()
        })
    });
}
